import { useMutation, UseMutationOptions } from 'react-query';
import apiClient from 'src/queries/apiClient';
import { responseWrapper } from 'src/queries/helpers';

export function useDeleteTravelRequest(
  options?: UseMutationOptions<any, Error, { id: string; updateVersionNumber: number }>
) {
  const { mutate: deleteTravelRequest, isLoading } = useMutation<
    any,
    Error,
    { id: string; updateVersionNumber: number }
  >({
    mutationFn: (payload: { id: string; updateVersionNumber: number }) =>
      responseWrapper(apiClient.deleteTravelRequest, [payload]),
    ...options,
  });

  return {
    deleteTravelRequest,
    isLoading,
  };
}
